import { DaDataAddress, DaDataParty, DaDataResponse, DaDataSuggestion } from '@app/models/daData';
import { daDataClient, handleRequest } from '@app/services/httpClient';

import { IProps } from '../interfaces';

const SUPPORTED_LOCATIONS = [{ country_iso_code: 'RU' }, { country_iso_code: 'BY' }, { country_iso_code: 'KZ' }];

class DaData {
  private readonly endPoint: string;

  constructor({ baseEndPoint }: IProps) {
    this.endPoint = baseEndPoint;
  }

  async postSuggestAddress(query: string, signal?: AbortSignal): Promise<DaDataResponse<DaDataAddress[]>> {
    return handleRequest(daDataClient.post('/suggest/address', { query, locations: SUPPORTED_LOCATIONS }, { signal }));
  }

  async postSelectSuggestAddress(query: string): Promise<DaDataResponse<DaDataAddress>> {
    return handleRequest(daDataClient.post('/suggest/address', { query, count: 1 }));
  }

  async postSuggestParty(
    query: string,
    signal?: AbortSignal
  ): Promise<DaDataResponse<DaDataSuggestion<DaDataParty>[]>> {
    return handleRequest(daDataClient.post('/suggest/party', { query, count: 10 }, { signal }));
  }
}

export default DaData;
